export function setLead(state, lead) {
  state.data = { ...lead };
}

export function setLeadLoading(state, value) {
  state.leadLoading = value;
}
